module.exports = __webpack_public_path__ + "static/media/hydronomad-logo.571d3530.jpg";